import { discountPercent, hasDiscount, listedRetailPrice, sellingPrice } from '../utils/productPrice';

const ProductPrice = ({
  product,
  className = '',
  saleClassName = 'text-pink-600 font-bold',
  retailClassName = 'text-gray-400 line-through',
  showPercent = false,
}) => {
  const sale = sellingPrice(product);
  const retail = listedRetailPrice(product);
  const discounted = hasDiscount(product);

  return (
    <div className={`flex items-center gap-1.5 sm:gap-2 ${className}`}>
      {discounted ? <span className={retailClassName}>₹{retail}</span> : null}
      <span className={saleClassName}>₹{sale}</span>
      {discounted && showPercent ? (
        <span className="text-green-600 text-xs font-semibold">{discountPercent(product)}% OFF</span>
      ) : null}
    </div>
  );
};

export default ProductPrice;
